import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import SchedulingTable from "./SchedulingTable";
import EditEventModal from "./EditEventModal";
import TransferModal from "./TransferModal";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { listEmployeeScheduling } from "../../../../api/server";
import {
  deleteSchedulingEvent,
  transferEmployeeScheduling,
} from "../../../../features/scheduling/schedulingSlice";
import moment from "moment";

const SingleEventsReplacements = (props) => {
  const {
    fromDate,
    toDate,
    triggerFetch,
    activeEmployee,
    abscenceActions,
    setReplacedByEvents,
    triggerQueryTimestamp,
  } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const [modal, contextHolder] = Modal.useModal();
  const deleteScedulingLoading = useSelector(
    (state) => state.pendingActions["scheduling/delete"]
  );
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const [hasApprovedScheduling, setHasApprovedScheduling] = useState(false);
  const [sameChosenEventsBranches, setSameChosenEventsBranches] =
    useState(true);
  const [selectedEventsBranch, setSelectedEventsBranch] = useState(null);
  const [orders, setOrders] = useState([]);
  const [transferModalVisible, setTransferModalVisible] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [selectedGhosts, setSelectedGhosts] = useState([]);
  const [editEventVisible, setEditEventVisible] = useState(false);
  const [activeEditedRecord, setActiveEditedRecord] = useState(null);

  const branchId =
    activeEmployee &&
    activeEmployee.branch_active &&
    activeEmployee.branch_active[0].branch_id;

  useEffect(() => {
    if (!editEventVisible) {
      setActiveEditedRecord(null);
    }
  }, [editEventVisible]);

  const { isLoading, data } = useQuery(
    [scopePrefix, activeEmployee, fromDate, toDate, triggerQueryTimestamp],
    async () => {
      const employeeId = activeEmployee.id;
      const branchId = activeEmployee.branch_active[0].branch_id;
      const startDate = moment(fromDate).startOf("day");
      var endDate = moment(toDate).endOf("day");
      const newState = {
        current: 1,
        pageSize: 100,
        filter: {
          date: {
            $gt: startDate.format(),
            $lt: endDate.format(),
          },
        },
      };
      const listParams = { ...newState, scopePrefix, employeeId };
      const scheduling = await listEmployeeScheduling(listParams);
      let items = [];
      if (
        scheduling &&
        scheduling.data &&
        scheduling.data.items &&
        scheduling.data.items.length > 0
      ) {
        scheduling.data.items.forEach((item, i) => {
          let temp = { ...item };
          if (
            scheduling.data.effective_orders &&
            scheduling.data.effective_orders.length > 0
          ) {
            const order = scheduling.data.effective_orders.filter(
              (i) => i.id === item.order_id
            )[0];
            temp["order"] = order;
          }
          items.push(temp);
        });
      }

      if (
        scheduling &&
        scheduling.data &&
        scheduling.data.replacements &&
        scheduling.data.replacements.length > 0
      ) {
        scheduling.data.replacements.forEach((item, i) => {
          let temp = { ...item, ghost: true };

          if (
            scheduling.data.effective_orders &&
            scheduling.data.effective_orders.length > 0
          ) {
            const order = scheduling.data.effective_orders.filter(
              (i) => i.id === item.order_id
            )[0];
            temp["order"] = order;
          }
          items.push(temp);
        });
      }
      if (scheduling && scheduling.data && scheduling.data.effective_orders) {
        setOrders(scheduling.data.effective_orders);
      }

      if (
        scheduling &&
        scheduling.data &&
        scheduling.data.replaced_by &&
        scheduling.data.replaced_by.length > 0
      ) {
        let replacedBy = [];
        scheduling.data.replaced_by.forEach((item, i) => {
          let temp = { ...item };

          if (
            scheduling.data.effective_orders &&
            scheduling.data.effective_orders.length > 0
          ) {
            const order = scheduling.data.effective_orders.filter(
              (i) => i.id === item.order_id
            )[0];
            temp["order"] = order;
          }
          replacedBy.push(temp);
        });

        setReplacedByEvents(replacedBy);
      } else {
        setReplacedByEvents([]);
      }
      return items;
    },
    {
      staleTime: 0,
      enabled: fromDate !== undefined && toDate !== undefined,
    }
  );

  useEffect(() => {
    const chosenEvents =
      data &&
      data.filter((i) => [...selectedEvents, ...selectedGhosts].includes(i.id));
    const chosenPatientsBranches =
      chosenEvents && chosenEvents.map((i) => i.order.patient.branch);
    const allEqual =
      chosenPatientsBranches &&
      chosenPatientsBranches.every((val) => val === chosenPatientsBranches[0]);
    let hasAprroval = false;
    if (chosenEvents && chosenEvents.length > 0) {
      chosenEvents.forEach((item, i) => {
        if (item.approved) {
          hasAprroval = true;
        }
      });
    }
    setSameChosenEventsBranches(allEqual);
    if (
      allEqual &&
      chosenPatientsBranches &&
      chosenPatientsBranches.length > 0
    ) {
      setSelectedEventsBranch(chosenPatientsBranches[0]);
    } else {
      setSelectedEventsBranch(null);
    }
    setHasApprovedScheduling(hasAprroval);
  }, [selectedEvents, selectedGhosts, data]);

  const hideEvent = () => {
    setEditEventVisible(false);
  };

  const hideTransferModal = () => {
    setTransferModalVisible(false);
  };

  const onTransfer = async (params, form) => {
    const toDispatch = {
      ...params,
      effective_from: fromDate,
      effective_to: toDate,
    };
    const action = await dispatch(transferEmployeeScheduling(toDispatch));
    if (!action.error) {
      form.resetFields();
      setTransferModalVisible(false);
      triggerFetch(moment().format());
    }
  };

  const onSaveEventCompleted = async () => {
    setEditEventVisible(false);
    triggerFetch(moment().format());
  };

  const onDeleteScheduling = (record) => {
    const title = intl.formatMessage({
      id: `app.absences.deleteSchedulingTitle`,
    });
    const content = intl.formatMessage({
      id: "app.absences.deleteSchedulingContent",
    });
    modal.confirm({
      title: title,
      icon: <ExclamationCircleOutlined />,
      content: content,
      onOk() {
        return deleteScheduling(record);
      },
    });
  };

  const deleteScheduling = async (record) => {
    const params = {
      patientId: record.order.patient_id,
      branchId: record.order.patient.branch,
      schedulingEvent: { deleted: record.id },
    };
    await dispatch(deleteSchedulingEvent(params));
    triggerFetch(moment().format());
  };

  const onReplaceEmployee = (record) => {
    setEditEventVisible(true);
    setActiveEditedRecord(record);
  };

  const changeSelectedEvents = (newEvents) => {
    const chosenEvents = data.filter((i) => newEvents.includes(i.id));
    const eventsToDelete = chosenEvents
      .filter((j) => !j.ghost)
      .map((k) => k.id);
    const ghostsToDelete = chosenEvents.filter((j) => j.ghost).map((k) => k.id);
    setSelectedEvents(eventsToDelete);
    setSelectedGhosts(ghostsToDelete);
  };

  const onShowTransferScheduling = () => {
    setTransferModalVisible(true);
  };

  return (
    <div style={{}}>
      {contextHolder}
      <SchedulingTable
        events={data || []}
        loading={isLoading}
        onDelete={onDeleteScheduling}
        onReplaceEmployee={onReplaceEmployee}
        deleteScedulingLoading={deleteScedulingLoading}
        changeSelectedEvents={changeSelectedEvents}
        selectedEvents={[...selectedEvents, ...selectedGhosts]}
        onShowTransferScheduling={onShowTransferScheduling}
        hasApprovedScheduling={hasApprovedScheduling}
        sameChosenEventsBranches={sameChosenEventsBranches}
        abscenceActions={abscenceActions}
      />
      <EditEventModal
        visible={editEventVisible}
        hide={hideEvent}
        record={activeEditedRecord}
        orders={orders}
        onSaveEventCompleted={onSaveEventCompleted}
      />
      <TransferModal
        onHide={hideTransferModal}
        visible={transferModalVisible}
        onTransfer={onTransfer}
        employeeId={activeEmployee.id}
        selectedEvents={selectedEvents}
        selectedGhosts={selectedGhosts}
        branchId={selectedEventsBranch}
      />
    </div>
  );
};

export default SingleEventsReplacements;
